import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams, useHistory} from "react-router-dom";
import Button from '@material-ui/core/Button';
import ReactTooltip from "react-tooltip";
import {useLocalStorage} from "@rehooks/local-storage";
// @ts-ignore
import AdSense from 'react-adsense';
import {Actions} from "../store/Actions";
import {StoreState} from "../store/StoreState";
import {ServerApi} from "../ServerApi";
import {Word} from "../models/models";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-virtualized/styles.css';
import "./WordSearchComponent.scss";
import './WordDetailComponent.scss'


export const WordDetailComponent: React.FC<any> = () => {
	const history = useHistory();
	const dispatch = useDispatch();


	const {wordIdParam} = useParams();
	const user = useSelector((state: StoreState) => state.authInfo);
	const [wordDetail, setWordDetail] = useState<Word | null | undefined>(undefined);
	const [tooltipWords, setTooltipWords] = useState<Record<string, string>>({});
	const [printWords, setPrintWords, deletePrintWords] = useLocalStorage<Word[]>('printWords', []);


	useEffect(() => {
		if (wordIdParam) {
			ServerApi
				.getWord(Number(wordIdParam))
				.then(word => setWordDetail(word));
		}

		return () => {
			setWordDetail(undefined);
		};
	}, [wordIdParam]);


	const handleDescriptionClick = async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		if (e.target instanceof HTMLAnchorElement) {
			const href = e.target.getAttribute("href");
			const wordId = Number(href);

			if (wordId) {
				e.preventDefault();
				history.push(`/${wordId}`)
			}
		}
	};

	const handleDelete = (wordId: number) => {
		if (window.confirm("정말로 삭제하시겠습니까?")) {
			ServerApi
				.deleteWord(wordId)
				.then(() => {
					dispatch(Actions.deleteIndexWordAction(wordId));
					history.push("/")
				});
		}
	};


	const tempElement = document.createElement('div');
	tempElement.innerHTML = wordDetail?.description ?? "";
	const anchors = tempElement.getElementsByTagName('a');
	Array.from(anchors).forEach((el) => {
		const wordId = Number(el.getAttribute("href"));
		if (wordId) {
			el.setAttribute("data-tip", wordId.toString());
		}
	});

	const htmlRenderedDescription = React.createElement("div", {
		dangerouslySetInnerHTML: {
			__html: tempElement.innerHTML
		}
	});


	return (
		<div className="grid-container2">

			{wordDetail === undefined
				? <strong className='loading-indicator'>로딩중...</strong>

				: wordDetail === null
					? <strong>해당 용어가 존재하지 않습니다.</strong>

					: <div className="word-detail">
						<div style={{float: "right"}}>

							<ToastContainer
								position="bottom-right"
								autoClose={1000}
								hideProgressBar
								newestOnTop={false}
								closeOnClick
								rtl={false}
								pauseOnFocusLoss={false}
								draggable={false}
								pauseOnHover
							/>
							<Button onClick={() => {
								if (printWords.includes(wordDetail)) {
									alert("용어인쇄 목록에 이미 존재합니다.");
								} else {
									setPrintWords([...printWords, wordDetail]);

									toast.info("용어인쇄 목록에 추가되었습니다.", {
										position: "bottom-right",
										autoClose: 1000,
										hideProgressBar: true,
										closeOnClick: true,
										pauseOnHover: true,
										draggable: false,
										progress: undefined,
									});
								}
							}}>
								인쇄추가
							</Button>

							{(user?.role === "Admin" || user?.role === "Manager") &&
                            <>
                                <Button onClick={() => history.push(`/Words/Update/${wordDetail.id}`)}>수정</Button>
                                <Button onClick={() => handleDelete(wordDetail.id)}>삭제</Button>
                            </>
							}
						</div>

						<div style={{fontSize: "14px"}}>
							<p>[{wordDetail?.dictionaryGroup}] - [{wordDetail?.dictionary}]</p>
							<p>등록자 : {wordDetail?.registrant}</p>
							<p>업데이트 : {new Date(wordDetail!?.updatedWhen).toLocaleString("ko-KR")}</p>
						</div>

						<h2 style={{textAlign: "center", marginBottom: "50px"}} className="term">{wordDetail?.term}</h2>

						<div className="description" onClick={handleDescriptionClick}>
							{htmlRenderedDescription}
						</div>

						<div style={{marginTop: "50px"}}>
							<AdSense.Google
								client='ca-pub-1013125438130464'
								style={{width: 500, height: 300}}
								format=''/>
						</div>

						<ReactTooltip
							className="word-tooltip"
							effect="solid"
							textColor="black"
							backgroundColor="white"
							border borderColor="black"
							overridePosition={(
								{left, top},
								currentEvent, currentTarget, node) => {
								const d = document.documentElement;
								// @ts-ignore
								left = Math.min(d.clientWidth - node.clientWidth, left);
								// @ts-ignore
								top = Math.min(d.clientHeight - node.clientHeight, top);
								left = Math.max(0, left);
								top = Math.max(0, top);
								return {top, left}
							}}
							delayShow={800}
							delayUpdate={800}
							delayHide={300}
							// afterShow={(e) => {
							// 	console.dir(e)
							// }}
							getContent={wordId => {
								if (!wordId) return null;

								if (!tooltipWords[wordId]) {
									ServerApi
										.getWord(parseInt(wordId))
										.then(word => {
											setTooltipWords({...tooltipWords, [wordId]: word?.description ?? "해당 용어가 존재하지 않습니다."})
										});
								}

								return (
									<>
										{React.createElement("div", {
											dangerouslySetInnerHTML: {
												__html: tooltipWords[wordId]
											}
										})}
									</>
								);
							}}/>
					</div>
			}

		</div>
	)
};